import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <h3 className="footer-logo">GlucoPlanner</h3>
            <p className="footer-description">
              AI-powered diabetes treatment assistant for healthcare professionals.
            </p>
          </div>
          
          <div className="footer-links">
            <div className="footer-section">
              <h4 className="footer-section-title">Product</h4>
              <ul className="footer-list">
                <li><a href="#features" className="footer-link">Features</a></li>
                <li><a href="#contact" className="footer-link">Contact</a></li>
              </ul>
            </div>
            
            <div className="footer-section">
              <h4 className="footer-section-title">Support</h4>
              <ul className="footer-list">
                <li><a href="#contact" className="footer-link">Help Center</a></li>
                <li><a href="#" className="footer-link">Terms of Service</a></li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} GlucoPlanner. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
